import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { Modal } from "antd";

import { customInput } from "../../../../../../../common/custom-input";
import styles from "../../../../../JobStyle.module.css";

import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";

const FORM_NAME = "job_swms_emergency_contact_type_add_edit_modal";

const validate = (values) => {
  const errors = {};

  if (!values || !values.emergency_type || !String(values.emergency_type).trim()) {
    errors.emergency_type = "Emergency Type is required.";
  }

  return errors;
}

function EmergencyContactTypeEditModal({
  visible,
  handleSubmit,
  onClose,
  allTypes = [],
}) {
  const [saving, setSaving] = useState(false);

  const onModalSubmit = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    handleSubmit(onSubmit)(event);
  };

  const onSubmit = (values) => {
    const emergencyType = values && values.emergency_type;

    setSaving(true);
    onClose(true, { emergency_type: emergencyType })
    setSaving(false);
  };

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={() => onClose(false)}
      destroyOnClose
      maskClosable={false}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      width={700}
      getContainer={() => document.body}
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <div className="v2-modal-container">
        <form onSubmit={onModalSubmit}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className={styles.ModalHeading}>Edit Emergency Contact Type</div>
                <hr />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <div className={styles.Label}>Emergency Type</div>
                <Field
                  component={customInput}
                  name="emergency_type"
                  disabled={saving}
                  autoComplete="off"
                  className={styles.TextField}
                  maxLength={80}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
                {saving ? <CircularProgress size={20} /> : null}
                <button type="button" className={styles.OutlinedButton} onClick={() => onClose(false)} disabled={saving}>
                  Cancel
                </button>
                <button type="submit" className={styles.PrimaryButton} disabled={saving}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  enableReinitialize: true,
  validate
})(EmergencyContactTypeEditModal);
